import React from 'react';
import { motion } from 'framer-motion';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
export function Bonuses() {
  const bonuses = [{
    title: 'GUÍA DE PROVEEDORES ARGENTINOS',
    desc: 'Dónde comprar: paracord, hebillas, argollas, materiales, herramientas. Todo seleccionado para Argentina.',
    value: '$12.000'
  }, {
    title: '10 PRODUCTOS ARTESANALES EXTRA',
    desc: 'Ideas adicionales para venderle al mismo cliente y multiplicar tus ingresos. (Bandanas, Pecheras, Juguetes, etc.)',
    value: '$15.000'
  }, {
    title: 'CÓMO HACER UNA SOGA PARACORD',
    desc: 'Uno de los productos más rápidos y fáciles de vender. Ideal para generar tus primeras ganancias rápido.',
    value: '$10.000'
  }, {
    title: 'CÓMO VENDER POR REDES SOCIALES',
    desc: 'Cómo usar: Instagram, Facebook Marketplace, WhatsApp, Historias. Aunque tengas pocos seguidores.',
    value: '$15.000'
  }];
  return <section className="py-10 px-4 bg-brand-50" data-id="element-21">
      <div className="max-w-5xl mx-auto" data-id="element-22">
        <div className="text-center mb-6" data-id="element-23">
          <div className="inline-flex items-center justify-center gap-2 bg-brand-800 text-white px-5 py-2 rounded-full font-bold text-base md:text-lg shadow-lg" data-id="element-24">
            <CardGiftcardIcon fontSize="small" data-id="element-25" /> 4 BONOS ESTRATÉGICOS INCLUIDOS
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6" data-id="element-26">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl p-4 border-2 border-brand-100 shadow-md flex flex-col h-full" data-id="element-27">
              <div className="flex items-center gap-2 mb-2" data-id="element-28">
                <div className="bg-brand-100 text-brand-600 p-2 rounded-lg" data-id="element-29">
                  <CardGiftcardIcon fontSize="small" data-id="element-30" />
                </div>
                <h3 className="font-bold text-base text-slate-900" data-id="element-31">
                  BONUS {idx + 1} — {bonus.title}
                </h3>
              </div>
              <p className="text-slate-600 mb-3 flex-grow font-medium text-sm" data-id="element-32">
                {bonus.desc}
              </p>
              <div className="mt-auto pt-2 border-t border-slate-100 flex items-center justify-between" data-id="element-33">
                <span className="text-slate-400 line-through font-bold text-base" data-id="element-34">
                  {bonus.value}
                </span>
                <span className="text-green-600 font-extrabold text-lg bg-green-50 px-3 py-0.5 rounded-lg" data-id="element-35">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-gradient-to-r from-brand-800 to-brand-600 rounded-2xl p-5 text-center text-white shadow-xl max-w-3xl mx-auto" data-id="element-36">
          <p className="text-brand-200 font-bold mb-1 uppercase tracking-wider text-sm" data-id="element-37">
            Valor total de los bonos:
          </p>
          <div className="flex items-center justify-center gap-3 text-2xl md:text-3xl font-extrabold" data-id="element-38">
            <span className="line-through opacity-70" data-id="element-39">$52.000</span>
            <span data-id="element-40">→</span>
            <span className="text-yellow-400" data-id="element-41">GRATIS HOY</span>
          </div>
        </div>
      </div>
    </section>;
}